<template>
<div class="chapter">
<div class="inner_page">
<p class="tx" id="d12e42">OTHER BOOKS BY ACE COLLINS</p>
<p class="ext" id="d12e44"><i>Turn Your Radio On: The Stories Behind Gospel Music’s All-Time<br/> Greatest Songs</i></p>
<p class="ext" id="d12e49"><i>Stories Behind the Best-Loved Songs of Christmas</i></p>
<p class="ext" id="d12e52"><i>Stories Behind the Great Traditions of Christmas</i></p>
<p class="ext" id="d12e55"><i>Stories Behind the Hymns That Inspire America</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Coll_ISBN0310862558_epub_c2_r1.vue?6c914600